<template>
	<layout-admin>
		<h1 class="text-3xl font-semibold text-gray-900">{{ __("Contract") }}</h1>
		<hr class="my-2" />
		<tradable-terms-summary
			:offer="contract"
			v-bind:extended="true"
			:large-view="true"
		/>
		<hr class="my-2" />
		<div v-if="!showUploadForm">
			<ui-button
				v-on:click="
					getPdf(
						$route('admin.contracts_pdf', { id: contract.id, role: 'seller' })
					)
				"
				label="Confirmation PDF / Seller"
			/>
			<ui-button
				v-on:click="
					getPdf(
						$route('admin.contracts_pdf', { id: contract.id, role: 'buyer' })
					)
				"
				label="Confirmation PDF / Buyer"
			/>
			<ui-button
				v-on:click="showUploadForm = true"
				label="Upload Changed Contract PDF"
				type="secondary"
				v-if="canUpload && !showUploadForm"
			/>
		</div>

		<div v-if="showUploadForm">
			<h2 class="text-2xl font-semibold text-gray-900">
				{{ __("Upload Changed Contract PDF") }}
			</h2>
			<form @submit.prevent="submit" class="space-y-6">
				<div>
					<label class="block font-medium">{{
						__("Confirmation PDF / Seller")
					}}</label>
					<input
						type="file"
						@input="form.seller_pdf = $event.target.files[0]"
					/>
					<ui-validation-message :form="form" field="seller_pdf" />
				</div>

				<div>
					<label class="block font-medium">{{
						__("Confirmation PDF / Buyer")
					}}</label>
					<input type="file" @input="form.buyer_pdf = $event.target.files[0]" />
					<ui-validation-message :form="form" field="buyer_pdf" />
				</div>

				<progress
					v-if="form.progress"
					:value="form.progress.percentage"
					max="100"
				>
					{{ form.progress.percentage }}%
				</progress>
				<div class="pb-4" v-else>
					<ui-button v-on:click="submit()" label="Upload" />
					<ui-button
						v-on:click="showUploadForm = false"
						label="Cancel"
						type="secondary"
						class="pl-4"
					/>
				</div>
			</form>
		</div>
	</layout-admin>
</template>

<script>
export default {
	props: {
		contract: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			canUpload: this.$inertia.page.props.acl.upload_contract_pdf,
			showUploadForm: false,
			form: Vue.observable(
				this.$inertia.form({
					buyer_pdf: null,
					seller_pdf: null,
				})
			),
		};
	},
	computed: {
		contractConfirmUrl: function () {
			return (
				window.baseUrl + "/contract/" + this.contract.id + "/confirmation_pdf"
			);
		},
	},
	methods: {
		getPdf(url) {
			window.location = url;
		},
		submit() {
			let that = this;
			this.form.post(
				this.$route("admin.contracts_upload", { id: this.contract.id }),
				{
					onSuccess() {
						that.showUploadForm = false;
						alert("Contracts updated!");
					},
				}
			);
		},
	},
};
</script>
